import '@mdxeditor/editor/style.css'

import {
  BoldItalicUnderlineToggles,
  BlockTypeSelect,
  CreateLink,
  InsertTable,
  InsertThematicBreak,
  ListsToggle,
  MDXEditor,
  Separator,
  UndoRedo,
  Button,
  codeBlockPlugin,
  codeMirrorPlugin,
  headingsPlugin,
  linkDialogPlugin,
  linkPlugin,
  listsPlugin,
  markdownShortcutPlugin,
  quotePlugin,
  tablePlugin,
  thematicBreakPlugin,
  toolbarPlugin,
  applyBlockType$,
} from '@mdxeditor/editor'

import PropTypes from 'prop-types'

const MarkdownEditor = ({ handleChange, placeholder, initialMarkdown }) => {
  return (
    <MDXEditor
      markdown={initialMarkdown}
      onChange={handleChange}
      contentEditableClassName='markdown-editor'
      placeholder={placeholder}
      plugins={[
        toolbarPlugin({
          toolbarContents: () => (
            <>
              <BlockTypeSelect />
              <Separator />
              <UndoRedo />
              <Separator />
              <BoldItalicUnderlineToggles />
              <Separator />
              <ListsToggle />
              <Button onClick={() => applyBlockType$('quote')} title='Quote'>
                &ldquo;
              </Button>
              <Separator />
              <CreateLink />
              <Separator />
              <InsertTable />
              <InsertThematicBreak />
            </>
          ),
        }),
        headingsPlugin({ allowedHeadingLevels: [1, 2, 3, 4, 5, 6] }),
        listsPlugin(),
        quotePlugin(),
        thematicBreakPlugin(),
        linkPlugin(),
        linkDialogPlugin(),
        tablePlugin(),
        codeBlockPlugin({ defaultCodeBlockLanguage: 'js' }),
        codeMirrorPlugin({ codeBlockLanguages: { js: 'JavaScript', css: 'CSS', txt: 'Text', tsx: 'TypeScript', html: 'HTML' } }),
      ]}
    />
  )
}

export default MarkdownEditor

MarkdownEditor.propTypes = {
  handleChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  initialMarkdown: PropTypes.string,
}
